import handleFormSubmit from './contactSubmit'

function shouldShowElement(child, selectorToShow) {
  if (
    child.classList.contains(selectorToShow) ||
    child.classList.contains('fe__wrapper--radio')
  ) {
    return true;
  }
  return false;
}

function resetRequiredInputs(inputs) {
  for (let i = 0; i < inputs.length; i++) {
    let input = inputs[i]
    input.removeAttribute('required')
  }
}
function setRequiredInputs(inputs) {
  for (let i = 0; i < inputs.length; i++) {
    let input = inputs[i]
    if (input.getAttribute('data-required') === 'true') {
      input.setAttribute('required', 'required')
    }
  }
}

function showSelectedForm(form, checkedRadio) {
  const selectorToShow = checkedRadio;
  const children = form.querySelectorAll('.fe__wrapper')
  let child;
  let inputs;

  for (let c = 0; c < children.length; c++) {
    child = children[c];
    inputs = child.querySelectorAll('.fe__input')

    child.classList.add('hidden')
    resetRequiredInputs(inputs)
    if (shouldShowElement(child, selectorToShow)) {
      child.classList.remove('hidden')
      setRequiredInputs(inputs)
    }
  }
}

function shouldButtonShow(form, selectedRadio) {
  const button = form.querySelectorAll('button')[0];
  button.classList.add('btn-hidden');
  if (selectedRadio) {
    button.classList.remove('btn-hidden');
  }
}

function toggleForm(form, checkedRadio) {
  showSelectedForm(form, checkedRadio)
  shouldButtonShow(form, checkedRadio)
}

function addFormToggleListeners(form, radio) {
  radio.addEventListener('change', function(){
    toggleForm(form, radio.value)
  })
}

(function(){
  const forms = document.querySelectorAll('.dynamic-form')
  for (let i = 0; i < forms.length; i++) {
    const form = forms[i]
    const radios = form.querySelectorAll('input[type="radio"]')
    let checkedRadio
    let radio
    for (var l = 0; l < radios.length; l++) {
      radio = radios[l]
      if (radio.checked) {
        checkedRadio = radio.value;
      }
      addFormToggleListeners(form, radio)
    }
    toggleForm(form, checkedRadio)
    handleFormSubmit(form)
  }
})();


// WEBPACK FOOTER //
// ./assets/js/forms/dynamicForm.js